<template>
  <div>
    <div v-if="isAllowed" class="wrapper-content w-100" id="delegaciones-consulta">
      <hr>
      <h2>{{title}}</h2>
      <h4>{{subTitle}}</h4>
      <div>
        <LmBreadcrumb v-if="showBreadcrumb" />
        <LmForm ref="lmFormRef">
          <LmComponentLoading v-if="isLoading"/>
          <div class="row">
            <LmNumberInputGroup
              autofocus
              class="col-12 col-lg-6"
              v-model="form.numeroDocumento"
              :v="$v.form.numeroDocumento"
              label="Documento"
              placeholder="Solo números"
              :buttonName="$t('search')"
              @click="search"
              :isProcessing="formIsProcessing"
              />
          </div>
          <hr>
          <div class="row" v-if="!vecinoNoEncontrado && !isLoading">
            <LmTextInput
              class="col-12 col-lg-1"
              v-model="vecino.tipoDeDocumento"
              label="Tipo"
              :disabled="true"
            />
            <LmTextInput
              class="col-12 col-lg-3"
              v-model="vecino.numeroDocumento"
              label="Documento"
              :disabled="true"
            />
            <LmTextInput
              class="col-12 col-lg-4"
              v-model="vecino.nombre"
              label="Nombre"
              :disabled="true"
            />
            <LmTextInput
              class="col-12 col-lg-4"
              v-model="vecino.apellido"
              label="Apellido"
              :disabled="true"
            />
            <LmTextInput
              class="col-12 col-lg-3"
              v-model="vecino.telefono"
              label="Teléfono"
              :disabled="true"
            />
            <LmTextInput
              class="col-12 col-lg-3"
              v-model="vecino.correoElectronico"
              label="Correo Electrónico"
              :disabled="true"
            />
            <LmTextInput
              class="col-12 col-lg-6"
              v-model="vecino.direccion"
              label="Dirección"
              :disabled="true"
            />
          </div>
          <div class="row" v-else>
            <b-col cols="12">
              <b-alert show variant="danger">Vecino no encontrado</b-alert>
            </b-col>
          </div>
          <LmButton
            id="cancel-button"
            type="button"
            buttonClass="btn-secondary"
            :isProcessing="formIsProcessing"
            :value="$t('Cancel')"
            @click.native="cancelBtn"
            lmButtonRootWrapperClass="d-inline-block mr-1"
            lmButtonWrapperClass="col"
            />
        </LmForm>
      </div>
      <lmConfirmationModal ref="lmConfirmationDeleteModal" title="Aviso" message="Esta por eliminar la licencia.  Está seguro?"/>
    </div>
<!--     <LmListV2
      v-if="isAllowed"
      ref="lmlistv2"
      :listEndpointUri=listEndpointUri
    /> -->
    <div v-else class="wrapper-content w-100">
      <LmError
        title="Lo sentimos"
        :subtitle="'No puede ver esta página'"
      />
    </div>
  </div>
</template>

<script>
import commonsApi from '@/api/commons'
import { mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import LmForm from '@/components/form/LmForm.vue'
import LmButton from '@/components/form/elements/LmButton'
import LmNumberInputGroup from '@/components/form/elements/LmNumberInputGroup'
import LmNumberInput from '@/components/form/elements/LmNumberInput'
import LmTextInput from '@/components/form/elements/LmTextInput'
import lmToasts from '@/mixins/lmToasts.js'
import lmConfirmationModal from '@/components/modals/LmConfirmationModal'
import LmListV2 from '@/components/LmListV2'
import LmSuperPowerSelect from '@/components/form/elements/LmSuperPowerSelect.vue'
import lmSuperPowerSelectHelper from '@/mixins/LmSuperPowerSelectHelper.js'
import LmError from '@/components/LmError'

export default {
  mixins: [lmSuperPowerSelectHelper, lmToasts],
  components: {
    LmForm,
    LmButton,
    LmTextInput,
    LmNumberInput,
    LmNumberInputGroup,
    lmConfirmationModal,
    LmListV2,
    LmSuperPowerSelect,
    LmError
  },
  data () {
    return {
      showBreadcrumb: process.env.VUE_APP_SHOWBREADCRUMB === 'yes',
      isLoading: true,
      isAllowed: true,
      form: {
        numeroDocumento: null
      },
      initialForm: {},
      vecinoNoEncontrado: false,
      formIsProcessing: false,
      vecino: {}
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    subTitle: {
      type: String,
      required: true
    },
    listEndpointUri: {
      type: String,
      required: true
    },
    newEndpointUri: {
      type: String,
      required: true
    }
  },
  validations () {
    return {
      form: {
        numeroDocumento: {
          required
        }
      }
    }
  },
  methods: {
    ...mapActions('commons', ['updateItemDetail']),
    ...mapActions('settings', ['geAddOrEditSettings']),
    goBackBtn () {
      this.$router.go(-1)
    },
    cancelBtn () {
      this.$router.go(-1)
    },
    async search () {
      try {
        this.formIsProcessing = true
        const resp = await commonsApi.axiosGetWrapper(`/vecinos/consultas/pordocumento/${this.form.numeroDocumento}`)
        if (resp.data.vecinos) {
          this.vecino = resp.data.vecinos[0]
          this.vecinoNoEncontrado = false
        } else {
          this.vecinoNoEncontrado = true
          this.vecino = {}
          throw new Error('Vecino no encontrado')
        }
      } catch (e) {
        console.log(e)
        this.vecinoNoEncontrado = true
        this.vecino = {}
      } finally {
        this.formIsProcessing = false
      }
    },
    async save () {
      try {
        this.formIsProcessing = true
        await this.$refs.lmFormRef.validationForm(this.$v)
        const insertAttributes = {
          id: this.$route.params.id,
          start_time: this.form.fechaDesde,
          end_time: this.form.fechaHasta,
          reemplazante: this.form.reemplazante
        }
        this.updateItemDetail({
          path: this.newEndpointUri,
          data: insertAttributes
        })
          .then(resp => {
            this.$refs.lmlistv2.setDataPageAndComponentsProps()
            this.form = JSON.parse(this.initialForm)
            this.$refs.superpowerReemplazante.remove()
            this.lmToastSuccessMessage(`Se registró una nueva licencia para '${this.$route.params.id}'`, `Nueva Licencia`)
          })
          .finally(() => {
            this.$nextTick(() => { this.$v.form.$reset() })
            this.formIsProcessing = false
          })
      } catch (error) {
        console.log(error)
        this.formIsProcessing = false
      }
    }
  },
  created () {
    // (async () => {
    //   const insertAttributes = {
    //     validate: true
    //   }
    //   await this.updateItemDetail({
    //     path: this.newEndpointUri,
    //     data: insertAttributes
    //   })
    //     .catch(e => {
    //       this.isAllowed = false
    //     })
    // })()
    this.isLoading = false
    this.initialForm = JSON.stringify(this.form)
  }
}
</script>
